import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Button } from 'react-bootstrap'

import I18n from 'i18n'
import { joinKeys } from 'helpers/translations.helper'
import { SuccessToast, ErrorToast } from 'components/ui/toast/toastsTemplates'
import { IEvaluationResume } from 'models/evaluation.model'
import { evaluationsService } from 'api/courses/evaluations'
import { EvaluationResponseStatus } from 'enum/evaluationResponseStatus.enum'
import { useAccess } from 'contexts/AccessContext'
import ConfirmReset from './components/ConfirmReset'

const prefixTranslation = 'administration.monitor.evaluations.actions'

interface IProps {
  evaluationResume: IEvaluationResume
  onRefresh: () => void
}

const Actions: React.FC<IProps> = ({ evaluationResume, onRefresh }) => {
  const { t } = useTranslation()
  const { can } = useAccess()
  const canManageProgress = can('manageProgress')
  const { status, canRestart } = evaluationResume
  const [loading, setLoading] = useState(false)
  const [showConfirmReset, setShowConfirmReset] = useState(false)

  const handleAccept = async () => {
    setLoading(true)
    try {
      const isManager = true
      await evaluationsService.resetEvaluationResponse(
        evaluationResume.evaluationResponse?.id || 0,
        isManager
      )
      SuccessToast(I18n.t('administration.toastMessages.coursesReminder'))
      setShowConfirmReset(false)
      onRefresh()
    } catch (e) {
      ErrorToast(I18n.t('administration.toastMessages.coursesReminderError'))
    }
    setLoading(false)
  }

  if (!canManageProgress) {
    return null
  }

  return (
    <>
      <Button
        className="negative-primary"
        disabled={
          status === null ||
          status === undefined ||
          loading ||
          canRestart === false
        }
        onClick={async () => {
          setShowConfirmReset(true)
        }}
      >
        {t(joinKeys(prefixTranslation, 'reset'))}
      </Button>
      <ConfirmReset
        evaluationName={evaluationResume.name}
        show={showConfirmReset}
        onAccept={handleAccept}
        onClose={() => setShowConfirmReset(false)}
      />
    </>
  )
}

export default Actions
